import { render, staticRenderFns } from "./upcoming-action-documents.vue?vue&type=template&id=3866fb64"
import script from "./upcoming-action-documents.vue?vue&type=script&lang=js"
export * from "./upcoming-action-documents.vue?vue&type=script&lang=js"
import style0 from "./upcoming-action-documents.vue?vue&type=style&index=0&id=3866fb64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports